export default class HideOnValue {

    protected $root: JQuery<any>;
    protected $targets: JQuery<any>;

    public constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    public bindUI = () => {
        this.$targets = $('[data-hide_on="'+this.$root.data('target')+'"]');
        this.$root.on({ change: this.handleValue });
        this.handleValue();
    }

    public handleValue = () => {
        let value = this.$root.val();
        this.$targets.filter('[data-hide_on_value="' + value + '"]').val('').parent().hide();
        this.$targets.filter('[data-hide_on_value!="' + value + '"]').parent().show();
    }

}